module.exports = __webpack_public_path__ + "5173bee237342e14f7d6e18c9792005a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/p-peel/energizer.png
 ** module id = 475
 ** module chunks = 0
 **/